import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Dashboard.css";
import { Link } from "react-router-dom";
// import PersonIcon from "@material-ui/icons/Person";
import Avatar from "@material-ui/core/Avatar";
import { getUser } from "../../helpers";
import format from "date-fns/format";
import InputLabel from "@material-ui/core/InputLabel";
import { verHPC9 } from "../../constants/versionManager";
import { getWindowsOS } from '../../helpers';

class Dashboard extends Component {
   // constructor(props) {
   //   super(props);
   // }

   componentDidMount() {
      const { getDashboards, getVersionsOs, getVersionsApi } = this.props;
      const params = { datetime: format(Date.now(), "yyyy-MM-dd") };
      getDashboards(params);

      // バージョン取得
      let os = "";
      if(navigator.appVersion.indexOf("Windows ")!==-1){
         os = getWindowsOS();
      }else{
         os = navigator.platform;
      }
      let systemArchitecture = navigator.userAgent.indexOf('WOW64') !== -1 || navigator.userAgent.indexOf('Win64') !== -1 ? ' 64bit' : ' 32bit';
      params["os_info"]= os + systemArchitecture;
      getVersionsOs(params);
      getVersionsApi();
      // getVersions(params);
   }

   render() {
      const user = getUser();
      const {
         AllPCCount,
         AllUserCount,
         Hpa27PcCount,
         TodayPcCount,
         YesterdayPcCount,
      } = this.props.items;

      let LastDate = new Date();
      LastDate.setDate(LastDate.getDate() - 1);
      let TodayDate = new Date();
      TodayDate.setDate(TodayDate.getDate());

      return (
         <div className="dashboard-container">
            <div className="dashboard-layout__loginname">
               ログイン名：{user.username}
            </div>
            <div className="dashboard-center">
               <div className="dashboard-layout__item-maintitle">通知数</div>

               <div className="dashboard-layout">
                  <Link
                     className="dashboard-layout__item-border"
                     to={`/index.html?p=history&date=${format(
                        LastDate,
                        "yyyy/MM/dd"
                     )}`}
                  >
                     <div className="dashboard-layout__item-title">
                        昨日通知数
                     </div>

                     <div className="dashboard-layout__item-date">
                        <InputLabel>
                           {" "}
                           ( {format(LastDate, "yyyy/MM/dd")} ){" "}
                        </InputLabel>
                     </div>

                     <div className="dashboard-layout__item-text">
                        <Avatar
                           variant="square"
                           src="img/PC.png"
                           className="dashboard-layout__PCicon"
                        />
                        <h2>{YesterdayPcCount} 台</h2>
                     </div>
                  </Link>

                  <Link
                     className="dashboard-layout__item-border"
                     to={`/index.html?p=history&date=${format(
                        TodayDate,
                        "yyyy/MM/dd"
                     )}`}
                  >
                     <div className="dashboard-layout__item-title">
                        本日通知数
                     </div>

                     <div className="dashboard-layout__item-date">
                        <InputLabel>
                           ( {format(TodayDate, "yyyy/MM/dd")} )
                        </InputLabel>
                     </div>

                     <div className="dashboard-layout__item-text">
                        <Avatar
                           variant="square"
                           src="img/PC.png"
                           className="dashboard-layout__PCicon"
                        />
                        <h2>{TodayPcCount} 台</h2>
                     </div>
                  </Link>
               </div>

               <div className="dashboard-layout__item-maintitle">
                  使用状況集計
               </div>

               <div className="dashboard-layout">
                  <Link
                     className="dashboard-layout__item-border"
                     to="/index.html?p=pcspec"
                  >
                     <div className="dashboard-layout__item-title">
                        システム導入数
                     </div>
                     <div className="dashboard-layout__item-text">
                        <Avatar
                           variant="square"
                           src="img/system.png"
                           className="dashboard-layout__icon"
                        />
                        <h2>{Hpa27PcCount} 台</h2>
                     </div>
                  </Link>

                  <Link
                     className="dashboard-layout__item-border"
                     to="/index.html?p=setting&id=1"
                  >
                     <div className="dashboard-layout__item-title">
                        ユーザー数
                     </div>
                     <div className="dashboard-layout__item-text">
                        <Avatar
                           variant="square"
                           src="img/user_menu.png"
                           className="dashboard-layout__icon"
                        />
                        <h2>{AllUserCount} 人</h2>
                     </div>
                  </Link>

                  <Link
                     className="dashboard-layout__item-border"
                     to="/index.html?p=terminal"
                  >
                     <div className="dashboard-layout__item-title">
                        管理端末数
                     </div>
                     <div className="dashboard-layout__item-text">
                        <Avatar
                           variant="square"
                           src="img/com.png"
                           className="dashboard-layout__icon"
                        />
                        <h2>{AllPCCount} 台</h2>
                     </div>
                  </Link>
               </div>

               <div className="dashboard-layout__item-title">
                  端末管理システム (HPC-9) Version：{verHPC9} - API Version: {this.props.api_version_info}
               </div>

               <div className="dashboard-layout__item-title">
                  データ収集ソフト (HPA-27) Version：{this.props.version_info}
               </div>
            </div>
         </div>
      );
   }
}

Dashboard.propTypes = {
   getDashboards: PropTypes.func.isRequired,
};

export default Dashboard;
